import { render, staticRenderFns } from "./TabPanel.vue?vue&type=template&id=49656a04&"
import script from "./TabPanel.vue?vue&type=script&lang=ts&"
export * from "./TabPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports